import { addToCartCheckoutAnalytics, removeFromCartCheckoutAnalytics } from './shop-checkout-analytics.js';
import epiforms from '../../../frontend/js/epiforms.js';
epiforms();
class ShopCheckout {
    constructor(checkoutPage) {
        this.handleNumberValueTimers = new Map();
        this.enforceLimitsTimers = new Map();
        this.initialize(checkoutPage);
    }

    initialize(checkoutPage) {
        this.detailedCart = checkoutPage.querySelector('#detailed-cart');
        this.orderForm = checkoutPage.querySelector('.order-form');
        this.detailedCartSum = checkoutPage.querySelector('#detailed-cart-sum');

        [...checkoutPage.querySelectorAll('.detailed-cart__item')].forEach((details) => {
            const removeButton = details.querySelector('.detailed-cart__remove');
            removeButton.addEventListener('click', (e) => {
                removeFromCartCheckoutAnalytics(e);
                this.removeProduct(details, details.dataset.productid)
            });

            const decreaseButton = details.querySelector('.detailed-cart__amount-button--less');
            const increaseButton = details.querySelector('.detailed-cart__amount-button--more');
            const numberField = details.querySelector('.detailed-cart__amount-field');

            if (increaseButton && decreaseButton) {
                increaseButton.addEventListener('click', () => this.handleNumberValue(details, numberField, true, details.dataset.productid));
                decreaseButton.addEventListener('click', () => this.handleNumberValue(details, numberField, false, details.dataset.productid));
            }

            if (numberField) {
                numberField.addEventListener('input', () => this.enforceLimits(details, numberField, details.dataset.productid));
                numberField.addEventListener('change', () => this.enforceLimits(details, numberField, details.dataset.productid));
            }
        });
    }

    handleNumberValue = (details, numberField, increase, productId) => {
        this.detailedCartSum.classList.add('detailed-cart-sum--loading');
        details.classList.add('detailed-cart__item--loading');
        const min = parseInt(numberField.getAttribute('min')) || 0;
        const max = parseInt(numberField.getAttribute('max')) || 99;
        const value = parseInt(numberField.value) || min;

        numberField.value = Math.min(max, Math.max(min, increase ? value + 1 : value - 1));

        clearTimeout(this.handleNumberValueTimers.get(productId));

        this.handleNumberValueTimers.set(productId, setTimeout(() => {
            this.updateCartAfterAmountChanged(details, numberField.value, productId);
        }, 1000));
    };

    enforceLimits = (details, numberField, productId) => {
        this.detailedCartSum.classList.add('detailed-cart-sum--loading');
        details.classList.add('detailed-cart__item--loading');
        const min = parseInt(numberField.getAttribute('min')) || 0;
        const max = parseInt(numberField.getAttribute('max')) || 99;
        const value = parseInt(numberField.value);

        if (isNaN(value) || numberField.value.trim() === "") {
            numberField.value = min;
        } else {
            numberField.value = Math.min(max, Math.max(min, value));
        }

        clearTimeout(this.enforceLimitsTimers.get(productId));

        this.enforceLimitsTimers.set(productId, setTimeout(() => {
            this.updateCartAfterAmountChanged(details, numberField.value, productId);
        }, 1000));
    };

    updateCartAfterAmountChanged(details, amount, productId) {
        const self = this;
        this.detailedCart.classList.add('detailed-cart--loading');
        this.detailedCartSum.classList.add('detailed-cart-sum--loading');
        details.classList.add('detailed-cart__details--loading');

        fetch(`/api/v2/cart/update/${productId}/${amount}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
        })
            .then(response => {
                return response.json();
            })
            .then((response) => self.handleCartUpdated(response))
            .catch(error => console.error('Error:', error));
    }

    removeProduct = (details, productId) => {
        const self = this;
        this.detailedCart.classList.add('detailed-cart--loading');
        this.detailedCartSum.classList.add('detailed-cart-sum--loading');
        details.classList.add('detailed-cart__details--loading');

        fetch(`/api/v2/cart/remove/${productId}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
        })
            .then(response => {
                return response.json();
            })
            .then((response) => self.handleCartUpdated(response))
            .catch(error => console.error('Error:', error));
    }

    handleCartUpdated = (response) => {
        fetch('/api/v2/cart/partials/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
        })
            .then(response => response.json())
            .then(response => {
                if (!(response?.cart?.products?.length)) {
                    window.location.href = "../";
                }

                this.detailedCart.outerHTML = response.detailedCartHtml;
                this.detailedCartSum.outerHTML = response.detailedCartSumHtml;

                if (this.orderForm) {
                    this.orderForm.value = response.orderForm;
                }

                const totalAmount = response.cart?.products?.reduce((sum, p) => sum + p.amount, 0) ?? 0;
                const cartAriaLabel = `Gå till kassan (${totalAmount} produkter)`;
                const headerCartElement = document.getElementById('header-cart');
                const headerCartMobileElement = document.getElementById('header-cart-mobile');
                if (headerCartElement) {
                    headerCartElement.dataset.products = totalAmount;
                    headerCartElement.setAttribute('aria-label', cartAriaLabel);
                }
                if (headerCartMobileElement) {
                    headerCartMobileElement.dataset.products = totalAmount;
                    headerCartMobileElement.setAttribute('aria-label', cartAriaLabel);
                }

                const checkoutPage = document.querySelector('.shop-page--checkout');
                this.initialize(checkoutPage);
                addToCartCheckoutAnalytics()
            })
            .catch(error => console.error('Error:', error));
    };
}

document.addEventListener('DOMContentLoaded', () => {
    const checkoutPage = document.querySelector('.shop-page--checkout');
    checkoutPage && new ShopCheckout(checkoutPage);
});
